import { executeRequest, Request } from '@jfs/network'
import { mimeTypes } from '../../src/data/static/data'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const downloadReportFileReq: any = (payload: any, tokens: any, method: string) => {
  const config = sitConfig(tokens)
  const request: Request<{}> = {
    config: config,
    apiPath: APIEndPoints.downloadSettlementReportFormat,
    method: method,
    body: payload,
    responseType: 'arraybuffer',
  }
  return executeRequest(request).then((data) => {
    return data
  })
}

const downloadFile = (resp: any, fileName: string) => {
  let contentType = resp.headers['content-type']
  if (mimeTypes.get(contentType) === undefined) {
    return
  } else {
    const blob = new Blob([resp?.data], { type: contentType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = `${fileName}${mimeTypes.get(contentType)}`
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }
}

export { downloadReportFileReq, downloadFile }
